export const REPORT_KEY = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAIL: 'LOGIN_FAIL',
  SWITCH_TO_MOBILE: 'SWITCH_TO_MOBILE',
  SWITCH_TO_WEB: 'SWITCH_TO_WEB',
  SEND_FIRST_MESSAGE: 'SEND_FIRST_MESSAGE',
  VIDEO_CALL: 'VIDEO_CALL',
  AUDIO_CALL: 'AUDIO_CALL',
};
